const Config = {
	api:{
		basepath : process.env.REACT_APP_KHAJIIT_BASEPATH,
		client: process.env.REACT_APP_KHAJIIT_CLIENT,
		secret: process.env.REACT_APP_KHAJIIT_SECRET
	},
	pagination:{
		limit: process.env.REACT_APP_PAGE_ITEMS
	},
	tawktoid:{
		id: process.env.REACT_APP_KHAJIIT_TAWKTOID
	},
	paypal: {
		client: process.env.REACT_APP_PAYPAL_CLIENT
	},
	admin: {
		email: process.env.REACT_APP_ADMIN_EMAIL
	},
	SocialMedia: {
		facebooklink:process.env.REACT_APP_LINK_FACEBOOK,
		twitterlink: process.env.REACT_APP_LINK_TWITTER,
		instagramlink: process.env.REACT_APP_LINK_INSTAGRAM,
		youtubelink: process.env.REACT_APP_LINK_YOUTUBE
	},
	woocommerce:{
		key:process.env.REACT_APP_CONSUMER_KEY,
		secret:process.env.REACT_APP_CONSUMER_SECRET
	}
		
	
}

module.exports = Config;